/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_EyebrowInputs */

const tr_landing_pricerules_eyebrow = /** @type {(inputs: Landing_Pricerules_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`döviz tetikli fiyatlandırma`)
};

const en_landing_pricerules_eyebrow = /** @type {(inputs: Landing_Pricerules_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FX-triggered pricing`)
};

const de_landing_pricerules_eyebrow = /** @type {(inputs: Landing_Pricerules_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kursgesteuerte Preise`)
};

const ru_landing_pricerules_eyebrow = /** @type {(inputs: Landing_Pricerules_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`цены по курсу валют`)
};

/**
* | output |
* | --- |
* | "FX-triggered pricing" |
*
* @param {Landing_Pricerules_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_eyebrow = /** @type {((inputs?: Landing_Pricerules_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_eyebrow(inputs)
	if (locale === "de") return de_landing_pricerules_eyebrow(inputs)
	if (locale === "ru") return ru_landing_pricerules_eyebrow(inputs)
	return tr_landing_pricerules_eyebrow(inputs)
});